import { floorPlanElementUuid } from '../internal/floor-plan-uuid';
import type { UppFloorPlanModel } from '../plan/floor-plan-model';
import { UppFloorPlanVertex } from '../plan/floor-plan-element';

/**
 * Vertex from which the dashed perimeter preview starts (marker centre in cm), matching host behaviour.
 */
export function resolveFloorPlanPerimeterPreviewSourceVertex(
  model: UppFloorPlanModel,
  anchorVertexId: string | null | undefined,
): UppFloorPlanVertex | null {
  if (anchorVertexId) {
    const t = anchorVertexId.trim();
    const v =
      model.elements.find(
        (e): e is UppFloorPlanVertex =>
          e instanceof UppFloorPlanVertex && e.uuid === t,
      ) ??
      model.elements.find(
        (e): e is UppFloorPlanVertex =>
          e instanceof UppFloorPlanVertex && e.uuid === floorPlanElementUuid(t),
      );
    return v ?? null;
  }
  const open = model.elements.filter(
    (e): e is UppFloorPlanVertex =>
      e instanceof UppFloorPlanVertex && !e.closed,
  );
  if (open.length === 0) {
    return null;
  }
  return open.reduce((a, b) => (a.sort >= b.sort ? a : b));
}

export function floorPlanPerimeterPreviewShouldDraw(params: {
  edit: boolean;
  roomBackgroundPointerMode: 'none' | 'doubleClickRoomCm';
  previewEndCm: { xCm: number; yCm: number } | null;
  model: UppFloorPlanModel | null;
  anchorVertexId: string | null | undefined;
}): boolean {
  return (
    params.edit &&
    params.roomBackgroundPointerMode === 'doubleClickRoomCm' &&
    params.previewEndCm !== null &&
    !!params.model &&
    !!resolveFloorPlanPerimeterPreviewSourceVertex(params.model, params.anchorVertexId ?? null)
  );
}
